<template>

    <div class="Logo">
        <h6>Agregar Logo</h6>
        <b-row>
            <b-col>
                <b-form-group id="input-group-3">

                    <b-form-file accept="image/*" size="sm" @change="readFile" id="logofile" ref="logofile" name="files[]" multiple browse-text="Examinar" placeholder="Seleccione una imagen.." />

                </b-form-group>
            </b-col>
            <b-col>
                <b-button variant="outline-success" class="mr-3" size="sm" @click="EnviarLogo"> <b-icon icon="arrow-up"></b-icon></b-button>
            </b-col>
        </b-row>





    </div>


</template>

<script>
    export default {
        name: 'Logo',

        data: function () {
            return { array: "", file: "" }
        },

        methods: {
            AddLogo: function (archivo) {
           this.array=archivo;

               
            },
            EnviarLogo: function () {
                if (this.array != "") {
                    this.$refs.logofile.value = "";
                    this.$emit('AddLogo', this.array);
                    this.array = "";
                 
                 

                }
                else {
                    alert("Debe seleccionar un archivo.");
                }
            },
            readFile: function (evt) {

                let files = evt.target.files;
                /*let output = [];
                /*let f = "";
                for (var i = 0; f = files[i]; i++) {
                    output.push(f.name);
                }*/
               // this.array = URL.createObjectURL(files[0]);
                this.AddLogo(URL.createObjectURL(files[0]));
               

                // this.logo = output;
             

            }


        }
    };
</script>

<style scoped>
</style>